import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Trans } from 'react-i18next'
import { history } from '@services/History'
import AccessControl from '../../auth/AccessControl'

export class SentenceTable extends Component {
  static defaultProps = {
    sentences: [],
  }

  static propTypes = {
    sentences: PropTypes.array,
  }

  render() {
    const { sentences } = this.props
    return (
      <table className="md-table">
        <thead>
          <tr>
            <th className="col-largest">
              <Trans>Frase</Trans>
            </th>
            <AccessControl>
              <th>
                <Trans>Compañías</Trans>
              </th>
            </AccessControl>
            <th>
              <Trans>Especialidades</Trans>
            </th>
            <th className="col-large">
              <Trans>Acciones</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {sentences.map((sentence) => (
            <tr key={sentence.id} onClick={() => history.extend(`/${sentence.id}`)}>
              <td className="col-show-content">{sentence.string}</td>
              <AccessControl>
                <td className="col-center">
                  {sentence.companies && sentence.companies.map((company) => company.name).join(', ')}
                </td>
              </AccessControl>
              <td className="col-center">
                {sentence.specialities && sentence.specialities.map((speciality) => speciality.name).join(', ')}
              </td>
              <td>
                <div className="actions-container">
                  <span className="far fa-eye" />
                  {sentence.is_editable && <span className="far fa-edit" />}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}
